/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export enum EventAction {
  clickProfile = "CLICK_PROFILE",
  changeLanguage = "CHANGE_LANGUAGE",
  selectStoreSearchresult = "SELECT_STORE_SEARCHRESULTS",
  searchOrderStore = "SEARCH_ORDER_STORE",
  clickOrderStoreSearchResult = "CLICK_ORDER_STORE_SEARCH_RESULT",
  clickStoreName = "CLICK_STORE_NAME",
  clickStoreSearch = "CLICK_STORE_SEARCH",
  clickFilterCity = "CLICK_FILTER_CITY",
  selectFilterCity = "SELECT_FILTER_CITY",
  clickHelpCenter = "CLICK_HELP_CENTER",
  hcHandoverFailed = "HC_HANDOVER_FAILED",
  createConnection = "CREATE_CONNECTION",
  closeConnection = "CLOSE_CONNECTION",
  switchConnection = "SWITCH_CONNECTION",
  pageView = "PAGEVIEW",
  clickOrders = "CLICK_ORDERS",
  changeViewMode = "CHANGE_VIEW_MODE",
  changeTab = "CHANGE_TAB",
  openOrderDetail = "OPEN_ORDER_DETAIL",
  markOrder = "MARK_ORDER",
  loadNextPage = "LOAD_NEXT_PAGE",
  selectAllRow = "SELECT_ALL_ROW",
  deselectAllRow = "DESELECT_ALL_ROW",
  selectExceededRow = "SELECT_EXCEEDED_ROW",
  selectSingleRow = "SELECT_SINGLE_ROW",
  deselectSingleRow = "DESELECT_SINGLE_ROW",
  clearSelection = "CLEAR_SELECTION",
  printSelectedReceipts = "PRINT_SELECTED_RECEIPTS",
  printSingleReceipt = "PRINT_SINGLE_RECEIPT",
  closeOrderDetail = "CLOSE_ORDER_DETAIL",
  changeHistoryDate = "CHANGE_HISTORY_DATE",
  changeHistoryStatusFilter = "CHANGE_HISTORY_STATUS_FILTER",
  displayMedia = "DISPLAY_MEDIA",
  errorPlayingSound = "ERROR_PLAYING_SOUND",
  clickEditOrder = "CLICK_EDIT_ORDER",
  clickReviewOrderButton = "CLICK_REVIEW_ORDER_BUTTON",
  clickConfirmEditedOrderButton = "CLICK_CONFIRM_EDITED_ORDER_BUTTON",
  adjustItemQuantity = "ADJUST_ITEM_QUANTITY",
  removeItem = "REMOVE_ITEM",
  changeSelectableModifier = "CHANGE_SELECTABLE_MODIFIER",
  changeChecboxModifier = "CHANGE_CHECKBOX_MODIFIER",
  adjustModifierQuantity = "ADJUST_MODIFIER_QUANTITY",
  failReviewOrder = "FAIL_REVIEW_ORDER",
  failConfirmEditedOrder = "FAIL_CONFIRM_EDITED_ORDER",
  clickGoToFinancePage = "CLICK_GO_TO_FINANCE_PAGE",
  loadMaxAPIStoreEmpty = "LOAD_MAX_API_STORE_EMPTY",
  downloadMpaFile = "DOWNLOAD_MPA_FILE",
  grabxFeatureFlagShadow = "GRABX_FEATURE_FLAG_SHADOW",
  copyToClipboardFailed = "COPY_TO_CLIPBOARD_FAILED",
  clickOutForDelivery = "CLICK_OUT_FOR_DELIVERY",
  confirmOutForDelivery = "CONFIRM_OUT_FOR_DELIVERY",
  clickCancelOrder = "CLICK_CANCEL_ORDER",
  submitCancelOrder = "SUBMIT_CANCEL_ORDER",
}

export enum EventCategory {
  storeTab = "STORE_TAB",
  ordersTab = "ORDERS_TAB",
  transactionTab = "TRANSACTION_TAB",
  // Troy MME
  orderHomePage = "ORDER_HOMEPAGE",
  orderListPage = "ORDER_LIST_PAGE",
  orderHistoryPage = "ORDER_HISTORY_PAGE",
  orderDetail = "ORDER_DETAIL",
  orderDetailEdit = "ORDER_DETAIL_EDIT",
  hermesConnection = "HERMES_CONNECTION",
  sidebarNavigation = "SIDE_BAR_NAVIGATION",
  notification = "NOTIFICATION",
}

export enum EventEntryPoint {
  orderListingPage = "ORDER_LISTING_PAGE",
}

export enum Language {
  en = "English",
  id = "Bahasa",
}

export enum EventLabelKeys {
  defaultLanguageShowed = "DEFAULT_LANGUAGE_SHOWED",
  selectedLanguage = "SELECTED_LANGUAGE",
  clickText = "CLICK_TEXT",
  filterText = "FILTER_TEXT",
}

export enum UserTypes {
  merchant = "MERCHANT",
  consumer = "CONSUMER",
  store = "STORE",
  individualMerchant = "INDIVIDUAL_MERCHANT",
  individualStore = "INDIVIDUAL_STORE",
  mlmMerchant = "MLM_MERCHANT",
  mlmStore = "MLM_STORE",
  mlmTerminal = "MLM_TERMINAL",
  gtwyMerchant = "GTWY_MERCHANT",
  gtwyStore = "GTWY_STORE",
  ptnrMerchant = "PTNR_MERCHANT",
  ptnrStore = "PTNR_STORE",
  offlineAcquirer = "OFFLINE_ACQUIRER",
}

export enum HermesEventType {
  Disconnected = "Disconnected",
  Unknown = "Unknown",
  Unauthorized = "Unauthorized",
  Conflict = "Conflict",
}

export enum NotificationMethod {
  Hermes = "Hermes",
  Fallback = "Fallback",
}

export enum ShowOn {
  InsidePageApp = "inside-page-app",
  OutsidePageApp = "outside-page-app",
  Unknown = "unknown",
}

/** SUBMIT_CANCEL_ORDER label `STATUS` (Order tab / order detail flow). */
export enum CancelOrderSubmitStatus {
  success = "SUCCESS",
  failure = "FAILURE",
}
